import React, { useCallback, useState } from "react";
import NoticesTable from "./NoticesTable";
import { getNotices } from "../../store/api/notices";
import { prepareParams } from "./utils";

const Notices = () => {
  const [loading, setLoading] = useState(false);
  const [total, setTotal] = useState(0);
  const [notices, setNotices] = useState([]);

  const fetchData = useCallback((params) => {
    setLoading(true);
    getNotices(prepareParams(params))
      .then(({ data }) => {
        setNotices(data.notices);
        setTotal(data.totalCount);
      })
      .catch(() => {
        // setError(true);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  return (
    <div className="page-wrapper">
      <h2 style={{ fontWeight: "bold" }}>Notices</h2>
      <NoticesTable
        notices={notices}
        handleFetch={fetchData}
        loading={loading}
        total={total}
        showFilters={true}
        visibleColumns={[
          "noticeDate",
          "title",
          "category",
          "filePath",
          "isPublished",
          "actions",
        ]}
      />
    </div>
  );
};

export default Notices;
